import { useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';
import Navigation from '@/components/Navigation';
import Hero from '@/components/Hero';
import About from '@/components/About';
import OurCapabilities from '@/components/OurCapabilities';
import WhyNyaxo from '@/components/WhyNyaxo';
import CaseStudies from '@/components/CaseStudies';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import Chatbot from '@/components/Chatbot';

// Service Pages
import ServicesOverviewPage from '@/pages/ServicesOverviewPage';
import AIStressTestingPage from '@/pages/AIStressTestingPage';
import ProcurementIntelligencePage from '@/pages/ProcurementIntelligencePage';
import WaterGasManagementPage from '@/pages/WaterGasManagementPage';
import ProjectManagementPage from '@/pages/ProjectManagementPage';
import DigitalTransformationPage from '@/pages/DigitalTransformationPage';
import LiveDemosPage from '@/pages/LiveDemosPage';
import BrochurePage from '@/pages/BrochurePage';
import BrochureCoverPage from '@/pages/BrochureCoverPage';

// Home Page Component
const HomePage = () => (
  <>
    <div id="hero">
      <Hero />
    </div>
    <div id="about">
      <About />
    </div>
    <div id="why-nyaxo">
      <WhyNyaxo />
    </div>
    <div id="capabilities">
      <OurCapabilities />
    </div>
    <div id="case-studies">
      <CaseStudies />
    </div>
    <div id="contact">
      <Contact />
    </div>
  </>
);

function App() {
  const location = useLocation();
  const isServicePage = location.pathname.startsWith('/services') || location.pathname === '/live-demos' || location.pathname === '/brochure' || location.pathname === '/brochure-cover';

  return (
    <div className="App bg-[#0D0D0D] min-h-screen">
      {/* Show navigation only on home page */}
      {!isServicePage && <Navigation />}
      
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesOverviewPage />} />
        <Route path="/live-demos" element={<LiveDemosPage />} />
        <Route path="/brochure" element={<BrochurePage />} />
        <Route path="/brochure-cover" element={<BrochureCoverPage />} />
        <Route path="/services/ai-stress-testing" element={<AIStressTestingPage />} />
        <Route path="/services/procurement-intelligence" element={<ProcurementIntelligencePage />} />
        <Route path="/services/water-gas-management" element={<WaterGasManagementPage />} />
        <Route path="/services/project-management" element={<ProjectManagementPage />} />
        <Route path="/services/digital-transformation" element={<DigitalTransformationPage />} />
      </Routes>
      
      {/* Show footer and chatbot on all pages except brochure */}
      {location.pathname !== '/brochure' && location.pathname !== '/brochure-cover' && (
        <>
          <Footer />
          <Chatbot />
        </>
      )}
    </div>
  );
}

export default App;